export default "__VITE_ASSET__395a8fcd__"